module.exports = __webpack_public_path__ + "static/media/BABAOJA.9204cb14.png";